import { Spinner } from './Spinner'
import { type StatusToggleProps } from '../constants/ui'
import '../styles/status-toggle.scss'

export function StatusToggle({
  checked,
  label,
  onLabel = 'Active',
  offLabel = 'Inactive',
  disabled = false,
  busy = false,
  onChange,
}: StatusToggleProps) {
  return (
    <button
      type="button"
      className={`status-toggle${checked ? ' status-toggle--on' : ''}`}
      role="switch"
      aria-checked={checked}
      title={label}
      aria-label={label}
      disabled={disabled || busy}
      aria-busy={busy}
      onClick={onChange}
    >
      {busy ? (
        <Spinner inline />
      ) : (
        <span className="status-toggle__track" aria-hidden>
          <span className="status-toggle__thumb" />
        </span>
      )}
      <span className="status-toggle__text">{checked ? onLabel : offLabel}</span>
    </button>
  )
}
